var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 57",
    width: 180,
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t\t.s1 { fill: #010202 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m28.8 0.4h122.4c15.4 0 27.9 12.5 27.9 28 0 15.5-12.5 28-27.9 28h-122.4c-15.4 0-27.9-12.5-27.9-28 0-15.5 12.5-28 27.9-28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m37.1 28.2l-15.1-14.2c-0.1 0.3-0.3 0.7-0.3 1.2v26.1c0 0.5 0.2 0.9 0.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.9 28.2l5 4.7 5.6-2.9c1.8-1 1.8-2.5 0-3.5l-5.7-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38 27.3l4.7-4.5-17.8-9.4c-0.8-0.4-1.5-0.5-2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38 29l-15.1 14.3c0.5 0.2 1.2 0.1 2.1-0.2l17.9-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m68.7 15q-1.6 0-2.6 1-1.1 1.1-1.1 2.7 0 1.6 1.1 2.7 1 1 2.6 1c1.4 0 2.6-0.7 3.2-1.9v-2h-3.3v1h2.2v0.8c-0.5 0.8-1.2 1.1-2.1 1.1q-1.2 0-1.9-0.7c-0.5-0.6-0.7-1.2-0.7-2 0-0.8 0.2-1.4 0.7-1.9q0.7-0.8 1.8-0.8c0.9 0 1.6 0.4 2.1 1.2l0.8-0.7c-0.6-1-1.6-1.5-2.8-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m73.3 15.1v7.3h4.7v-1.1h-3.6v-2.3h2.7v-1h-2.7v-1.9h3.5v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.6 15.1v1h2.4v6.3h1.1v-6.3h2.3v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m87.9 15.1h1.1v7.3h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m90.1 15.1v1h2.3v6.3h1.1v-6.3h2.4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m105.2 16q1 1.1 1 2.7 0 1.6-1 2.7-1.1 1-2.6 1c-1.1 0-1.9-0.3-2.6-1q-1.1-1.1-1.1-2.7 0-1.6 1.1-2.7 1.1-1 2.6-1c1 0 1.9 0.3 2.6 1zm-4.4 0.8c-0.5 0.5-0.7 1.1-0.7 1.9q0 1.1 0.7 1.9c0.5 0.5 1.1 0.8 1.8 0.8q1 0 1.8-0.8 0.7-0.7 0.7-1.9c0-0.8-0.2-1.4-0.7-1.9-0.5-0.5-1.1-0.8-1.8-0.8q-1.1 0-1.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m112.2 20l-4.2-5h-0.4v7.4h1.1v-4.9l4.3 5h0.4v-7.4h-1.1v4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m71.4 27.7q-2.7 0-4.5 2-1.9 1.8-1.9 4.6 0 2.8 1.9 4.7 1.8 1.9 4.5 1.9c2.5 0 4.6-1.4 5.7-3.4v-3.5h-5.7v1.8h3.7v1.4q-1.2 1.9-3.6 1.9-2 0-3.2-1.3-1.3-1.4-1.3-3.5 0-2 1.2-3.3 1.2-1.3 3.2-1.3c1.5 0 2.7 0.6 3.6 2l1.4-1.2q-1.7-2.8-5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m86.1 32.4c0.9 1 1.4 2.2 1.4 3.5q0 2.1-1.4 3.6c-1 0.9-2.1 1.4-3.4 1.4-1.4 0-2.5-0.5-3.4-1.4-1-1-1.4-2.2-1.4-3.6 0-1.3 0.4-2.5 1.4-3.5q1.4-1.4 3.4-1.4 2 0 3.4 1.4zm-5.4 1.4q-0.8 0.8-0.8 2.1c0 0.9 0.3 1.6 0.8 2.2q0.8 0.9 2 0.9 1.2 0 2-0.9c0.6-0.6 0.8-1.3 0.8-2.2q0-1.3-0.8-2.1-0.8-0.9-2-0.9c-0.8 0-1.5 0.2-2 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m96.4 32.4c1 1 1.4 2.2 1.4 3.5q0 2.1-1.4 3.6c-0.9 0.9-2.1 1.4-3.4 1.4-1.4 0-2.5-0.5-3.4-1.4-0.9-1-1.4-2.2-1.4-3.6 0-1.3 0.5-2.5 1.4-3.5q1.4-1.4 3.4-1.4 2 0 3.4 1.4zm-5.3 1.4q-0.8 0.8-0.8 2.1c0 0.9 0.2 1.6 0.8 2.2q0.8 0.9 2 0.9 1.2 0 2-0.9c0.5-0.6 0.8-1.3 0.8-2.2q0-1.3-0.8-2.1-0.8-0.9-2-0.9c-0.9 0-1.5 0.2-2 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m106.3 31.3h1.7v8.5c0 2.9-1.7 4.6-4.5 4.6q-2.5 0.1-4.3-1.7l1-1.5q1.6 1.4 3.2 1.4c1.7 0 2.7-1 2.7-2.7v-0.7c-0.7 0.9-1.7 1.3-3 1.3-1.3 0-2.3-0.4-3.2-1.3-0.8-0.9-1.2-2.1-1.2-3.4 0-1.5 0.4-2.6 1.2-3.5 0.9-0.9 1.9-1.3 3.2-1.3q2.1 0 3.2 1.6zm-1 6.6c0.6-0.5 0.8-1.3 0.8-2.2 0-2-1.2-2.9-2.7-2.9q-1.2 0-2 0.8-0.8 0.8-0.8 2.1 0 1.3 0.8 2.1c0.6 0.6 1.2 0.8 2 0.8 0.7 0 1.4-0.2 1.9-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m109.9 26.2h2v14.5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m121.9 36.6h-6.7c0.2 1.5 1.4 2.5 3 2.5q1.4 0 2.6-1.2l0.9 1.4q-1.5 1.5-3.6 1.5-2.1 0-3.5-1.4-1.4-1.4-1.4-3.5c0-1.4 0.5-2.6 1.4-3.5q1.3-1.4 3.3-1.5 1.8 0 3 1.3 1.2 1.3 1.2 3.1c0 0.4-0.1 0.9-0.2 1.3zm-6.7-1.6h4.9c0-1.4-1-2.3-2.3-2.3-1.3 0-2.3 0.9-2.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m132.2 28q1.8 0 3 1 1.1 1.1 1.1 2.8c0 1.2-0.4 2.2-1.1 2.9-0.8 0.7-1.8 1.1-3 1.1h-2.5v4.9h-2v-12.7zm-2.4 1.7v4.2h2.4c1.4 0 2.2-0.8 2.2-2.1 0-1.2-0.8-2.1-2.2-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m137.4 26.2h2v14.5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m148.5 34.9v5.7h-1.8v-1.1q-1 1.3-2.9 1.3c-1.9 0-3.2-1-3.2-2.7 0-1.6 1.3-2.7 3.4-2.7h2.5v-0.6c0-1.3-0.7-2-1.9-2q-1.4 0-2.6 1.4l-1.1-1.2q1.4-2 3.9-2c2.2 0 3.7 1.4 3.7 3.9zm-2 2.2v-0.2h-2.3q-1.6 0-1.6 1.2c0 0.8 0.6 1.2 1.6 1.2 1.3 0 2.3-0.9 2.3-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.9 38.1l-2.6-6.9h-2.1l3.6 9.1-0.3 0.8c-0.5 1.1-1.1 1.4-2 1.4-0.2 0-0.5 0-1.1-0.1v1.7c0.5 0.2 1 0.2 1.5 0.2 1.6 0 2.6-0.8 3.3-2.6l4.5-10.5h-2.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.cf9edd922593c2ce4f0eb1d1de8d35ba.svg";
export { ForwardRef as ReactComponent };